import React, { useState } from "react";
import Pagination from "./Pagination";

interface ListProps<T> {
    items: T[];
    onEdit: (item: T) => void;
    onDelete: (item: T) => void;
    renderItem: (item: T) => React.ReactNode;
    itemsPerPage?: number;
    usePagination?: boolean;
    allowDelete?: boolean; // Controls the visibility of the delete symbol
}

const List = <T, >({
                       items,
                       onEdit,
                       onDelete,
                       renderItem,
                       itemsPerPage = 10,
                       usePagination = false,
                       allowDelete = false,
                   }: ListProps<T>) => {
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ pageSize, setPageSize ] = useState(itemsPerPage);

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };

    const handlePageSizeChange = (newSize: number) => {
        setPageSize(newSize);
        setCurrentPage(1); // Reset to first page when page size changes
    };

    const startIndex = (currentPage - 1) * pageSize;
    const currentItems = items.slice(startIndex, startIndex + pageSize);

    return (
        <div className="list-container">
            {items.length === 0 ? (
                <div className="list-empty text-gray-700 dark:text-gray-400 italic">No items available.</div>
            ) : (
                <ul className="list">
                    {currentItems.map((item, index) => (
                        <li
                            key={index}
                            className="list-item"
                        >
                            <div className="list-item-content">
                                {renderItem(item)}
                            </div>
                            <div className="list-item-actions">
                                {!(item as any).public ? (
                                    <>
                                        <a
                                            className="list-item-button list-item-button-edit"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onEdit(item);
                                            }}
                                        >
                                            Edit
                                        </a>
                                        {allowDelete && (
                                            <a
                                                className="list-item-button list-item-button-delete"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onDelete(item);
                                                }}
                                            >
                                                Delete
                                            </a>
                                        )}
                                    </>
                                ) : null}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
            {usePagination && items.length > 0 && (
                <Pagination
                    total={items.length}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                />
            )}
        </div>
    );
};

export default List;